import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    margin: toRem(20),
    '& .OperateContainer': {
        background: theme.colors.blueLight,
        maxWidth: 1440,
        margin: 'auto',
        padding: toRem(20),
        borderRadius: 4,

        [theme.breakpoints.up('md')]: {
            padding: toRem(80)
        },

        '& .Title': {
            color: theme.colors.goldDark,
            fontSize: toRem(20),

            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(24),
                fontWeight: '500'
            }
        },

        '& .BlockCaption': {
            display: 'block',
            marginBottom: 0,
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                marginBottom: toRem(35)
            },
            '& .Subtitle': {
                flex: 1,
                marginBottom: toRem(45),
                fontSize: toRem(14),

                [theme.breakpoints.up('lg')]: {
                    marginBottom: 0,
                    fontSize: toRem(20)
                }
            },
            '& .Text': {
                flex: 1,
                fontSize: toRem(14),

                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(20)
                }
            }
        },

        '& .AccordionContainer': {
            maxWidth: 680,
            margin: '0 auto',
            padding: toRems([30, 0, 0, 0]),
            '& .AccordionBottom': {
                display: 'flex',
                padding: toRems([0, 20]),
                margin: toRems([60, 0, 20]),
                justifyContent: 'center',
                alignItems: 'center',
                [theme.breakpoints.up('md')]: {
                    justifyContent: 'space-between'
                },
                '& .AccordionText': {
                    display: 'none',
                    maxWidth: toRem(420),
                    paddingRight: toRem(20),
                    [theme.breakpoints.up('md')]: {
                        display: 'block'
                    }
                }
            }
        }
    }
})

export default style
